import { Extension, InputRule, markInputRule, textblockTypeInputRule, wrappingInputRule } from "@tiptap/core";
import { TextSelection } from "@tiptap/pm/state";

export const KlarityInputRules = Extension.create({
  name: "klarityInputRules",
  addInputRules() {
    const { nodes, marks } = this.editor.schema;
    const rules: InputRule[] = [];
    if (nodes.heading) {
      rules.push(
        textblockTypeInputRule({ find: /^#\s$/, type: nodes.heading, getAttributes: { level: 1, number: true } }),
        textblockTypeInputRule({ find: /^#{2,6}\s$/, type: nodes.heading, getAttributes: { level: 2, number: true } }),
      );
    }
    if (nodes.bulletList) rules.push(wrappingInputRule({ find: /^\s*([-+*])\s$/, type: nodes.bulletList }));
    if (nodes.orderedList) rules.push(wrappingInputRule({ find: /^(\d+)\.\s$/, type: nodes.orderedList }));
    if (nodes.codeBlock) rules.push(textblockTypeInputRule({ find: /^```$/, type: nodes.codeBlock }));
    if (nodes.klCallout) {
      rules.push(
        wrappingInputRule({ find: /^!>\s$/, type: nodes.klCallout, getAttributes: { kind: "warning", title: null } }),
        wrappingInputRule({ find: /^>\s$/, type: nodes.klCallout, getAttributes: { kind: "note", title: null } }),
      );
    }
    const pageBreak = nodes.pageBreak;
    const paragraph = nodes.paragraph;
    if (pageBreak && paragraph) {
      rules.push(
        new InputRule({
          find: /^---$/,
          handler: ({ state, range }) => {
            const $from = state.doc.resolve(range.from);
            // Only a paragraph holding nothing but the "---" typed so far; never replace existing text.
            if ($from.depth !== 1 || $from.parent.type !== paragraph || $from.parent.textContent !== "---") return null;
            const start = $from.before(1);
            const pb = pageBreak.create();
            state.tr.replaceWith(start, $from.after(1), [pb, paragraph.create()]);
            state.tr.setSelection(TextSelection.create(state.tr.doc, start + pb.nodeSize + 1));
          },
        }),
      );
    }
    const placeholder = nodes.placeholder;
    if (placeholder) {
      rules.push(
        new InputRule({
          find: /\[\[([^[\]]+)\]\]$/,
          handler: ({ state, range, match }) => {
            const label = match[1]?.trim();
            if (!label) return null;
            state.tr.replaceWith(range.from, range.to, placeholder.create({ label }));
          },
        }),
      );
    }
    if (marks.bold)
      rules.push(markInputRule({ find: /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, type: marks.bold }));
    if (marks.italic)
      rules.push(markInputRule({ find: /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, type: marks.italic }));
    if (marks.code) rules.push(markInputRule({ find: /(^|[^`])`([^`]+)`(?!`)$/, type: marks.code }));
    return rules;
  },
});
